var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('comment-nav',{attrs:{"userInfo":_vm.userInfo,"content_id":_vm.content_id,"content_kind":_vm.content_kind}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }